export default "__VITE_ASSET__$wqlzCa$__"